import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ProductSelectedPipe } from '@bca-receipt/pipes/product-selected.pipe';
import { ReceiptFooterComponent } from '@bca-receipt/receipt-footer/receipt-footer.component';
import { ReceiptDialog } from '@bca-receipt/receipt/receipt-dialog';
import { ReceiptItemComponent } from '@bca-receipt/receipt/receipt-item/receipt-item.component';
import { ReceiptComponent } from '@bca-receipt/receipt/receipt.component';
import { SharedModule } from '@bca-shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';

const dialogs = [ReceiptDialog];

@NgModule({
  declarations: [
    ReceiptComponent,
    ReceiptItemComponent,
    ReceiptFooterComponent,
    ProductSelectedPipe,
    ...dialogs
  ],
  imports: [CommonModule, SharedModule, TranslateModule.forChild()],
  exports: [ReceiptComponent, ReceiptFooterComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ReceiptModule {}
